<!-- カード有効期限 -->
<template>
  <div class="column">
    <label class="name">カード有効期限</label>
    <div class="value">
      {{ cardExp[2] }}{{ cardExp[3] }}/{{ cardExp[0] }}{{ cardExp[1] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentCardperiodDisp",
  props: {
    cardExp: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.column label {
  width: 110px;
  font-weight: normal;
  color: #888888;
}

.column .value {
  width: calc(100% - 110px);
  font-weight: bold;
}
</style>
